import {TeamFilterItemFragment} from '@/generated/graphql';
import {createContext, useContext, useState, useEffect, ReactNode} from 'react';

type TeamContextType = {
  teams: TeamFilterItemFragment[];
  selectedTeams: string[];
  setSelectedTeams: React.Dispatch<React.SetStateAction<string[]>>;
};

const defaultTeamContext: TeamContextType = {
  teams: [],
  selectedTeams: [],
  setSelectedTeams: () => {},
};

const TeamContext = createContext<TeamContextType>(defaultTeamContext);

export const useTeams = () => {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error('useTeams must be used within a TeamProvider');
  }
  return context;
};

export const useSelectedTeams = () => {
  const {selectedTeams} = useTeams();
  return selectedTeams;
};

type TeamProviderProps = {
  children: ReactNode;
  teams: TeamFilterItemFragment[];
};

export const TeamProvider = ({children, teams}: TeamProviderProps) => {
  const [selectedTeams, setSelectedTeams] = useState<string[]>([]);

  useEffect(() => {
    if (teams.length > 0 && selectedTeams.length === 0) {
      setSelectedTeams(teams.map(team => team.id));
    }
  }, [teams]);

  return (
    <TeamContext.Provider
      value={{
        teams,
        selectedTeams,
        setSelectedTeams,
      }}
    >
      {children}
    </TeamContext.Provider>
  );
};
